import { ChangeEvent } from "react";

import { useTranslation } from "react-i18next";

import { CookieItem, CookiesModalContentProps, SingleCookieItem } from "..";

export const CookiesModalContent = ({
    isAnalyticsCookies,
    setIsAnalyticsCookies
}: CookiesModalContentProps) => {
    const { t } = useTranslation();

    const handleAnalyticsToggleChange = (
        event: ChangeEvent<HTMLInputElement>
    ) => {
        setIsAnalyticsCookies(event.target.checked);
    };

    const COOKIE_ITEMS_LIST: CookieItem[] = [
        {
            haveItemSeparator: true,
            title: t("Cookies##essential cookies"),
            description: t("Cookies##essential cookies description"),
            label: t("Cookies##always active"),
            isToggleDisabled: true,
            isToggleChecked: true,
            onToggleChange: null,
            customStyle: undefined
        },
        {
            haveItemSeparator: false,
            title: t("Cookies##analytics cookies"),
            description: t("Cookies##analytics cookies description"),
            label: undefined,
            isToggleDisabled: false,
            isToggleChecked: isAnalyticsCookies,
            onToggleChange: handleAnalyticsToggleChange,
            customStyle: { paddingTop: "24px" }
        }
    ];

    return (
        <>
            {COOKIE_ITEMS_LIST.map(
                ({
                    title,
                    haveItemSeparator,
                    description,
                    label,
                    onToggleChange,
                    isToggleDisabled,
                    isToggleChecked,
                    customStyle
                }: CookieItem) => (
                    <SingleCookieItem
                        key={title}
                        isItemSeparator={haveItemSeparator}
                        cookieDescription={description}
                        cookieTitle={title}
                        switcherLabel={label}
                        onToggleChange={onToggleChange}
                        toggleDisable={isToggleDisabled}
                        toggleChecked={isToggleChecked}
                        customStyle={customStyle}
                    />
                )
            )}
        </>
    );
};
